export const knowledgeBase = {
  title: 'Base de conocimiento',
  subtitle:
    'Curá las fuentes que la generación de contenido va a tomar como verdad para esta organización.',

  sourceType: {
    url: 'URL',
    pdf: 'PDF',
    manual: 'Manual',
    content: 'Desde post',
  },

  status: {
    pending: 'Pendiente',
    indexing: 'Indexando',
    ready: 'Lista',
    failed: 'Falló',
  },

  actions: {
    newSource: 'Nueva fuente',
    reindex: 'Reindexar',
    refresh: 'Refrescar caché',
    delete: 'Borrar',
    openMenu: 'Abrir menú de acciones',
  },

  list: {
    authoritative: 'Autoritativa',
    expiringSoon: 'Vence pronto',
    untitled: 'Fuente sin título',
    columns: {
      title: 'Fuente',
      type: 'Tipo',
      status: 'Estado',
      tags: 'Tags',
      updated: 'Actualizada',
      actions: 'Acciones',
    },
    empty: {
      title: 'Todavía no hay fuentes',
      description: 'Agregá tu primera URL, PDF, nota manual o post publicado para empezar.',
    },
    filters: {
      searchPlaceholder: 'Buscar fuente…',
      status: {
        all: 'Todos los estados',
        ready: 'Listas',
        indexing: 'Indexando',
        pending: 'Pendientes',
        failed: 'Fallidas',
      },
      expiring: {
        any: 'Sin filtro de vencimiento',
        '7': 'Vence en ≤ 7 días',
        '30': 'Vence en ≤ 30 días',
        '90': 'Vence en ≤ 90 días',
      },
    },
  },

  addDialog: {
    title: 'Agregar a la base de conocimiento',
    description: 'Elegí de dónde sale la fuente. Todas se indexan y reutilizan en cada generación.',
  },

  picker: {
    back: 'Volver',
    disclaimer:
      'Solo cargá contenido que te pertenezca o para el cual tengas permiso. Las fuentes se usan exclusivamente dentro de esta organización.',
    url: {
      title: 'Desde una URL',
      description: 'Extraemos el contenido legible de una página pública.',
      formTitle: 'Agregar fuente desde URL',
      formDescription: 'Extraemos el <title> y el texto principal de la página automáticamente.',
    },
    pdf: {
      title: 'Desde un PDF',
      description: 'Subí un PDF y lo guardamos por vos.',
      formTitle: 'Agregar fuente desde PDF',
      formDescription: 'Subí el archivo y extraemos el texto automáticamente.',
    },
    manual: {
      title: 'Texto manual',
      description: 'Pegá T&C, FAQ o documentación interna directamente.',
      formTitle: 'Agregar fuente manual',
      formDescription: 'Usá este modo para texto que no vive en una URL pública.',
    },
    content: {
      title: 'Desde un post publicado',
      description: 'Referenciá un contenido ya existente en esta organización.',
      formTitle: 'Agregar fuente desde post',
      formDescription: 'Usamos la última versión completada del post como base.',
    },
    crawl: {
      title: 'Rastrear sitio',
      description:
        'Descubrí todas las URLs de un sitio vía sitemap o crawl y elegí cuáles importar como fuentes.',
    },
  },

  crawl: {
    tabs: {
      sitemap: 'Sitemap',
      crawl: 'Crawl',
    },
    input: {
      title: 'Rastrear sitio',
      description: 'Descubrí las URLs de un sitio y elegí cuáles importar.',
    },
    sitemap: {
      urlLabel: 'URL inicial',
      urlHelp:
        'Pegá la URL raíz del sitio. Buscamos /sitemap.xml automáticamente.',
      submit: 'Descubrir URLs',
      submitting: 'Descubriendo…',
    },
    crawl: {
      urlLabel: 'URL inicial',
      maxPagesLabel: 'Páginas máx.',
      maxDepthLabel: 'Profundidad máxima',
      submit: 'Iniciar rastreo',
      submitting: 'Iniciando…',
      progress: 'Rastreando… {{crawled}} páginas crawleadas, {{discovered}} descubiertas.',
    },
    review: {
      title: 'URLs descubiertas',
      description: 'Elegí cuáles importar como fuentes. Todas comparten la metadata.',
      summary: '{{discovered}} URLs descubiertas · {{selected}} seleccionadas',
      searchPlaceholder: 'Filtrar URLs…',
      selectAllVisible: 'Seleccionar todas las visibles',
      deselectAll: 'Deseleccionar todas las visibles',
      noMatches: 'Sin URLs que coincidan con el filtro.',
      metadataTitle: 'Metadata compartida',
      importCta: 'Importar {{count}} URLs',
      importing: 'Importando…',
    },
  },

  form: {
    titleLabel: 'Título',
    titleUrlPlaceholder: 'Dejalo vacío para usar el <title> de la página',
    titlePdfPlaceholder: 'Dejalo vacío para usar el nombre del archivo',
    titleManualPlaceholder: 'Ej: Velo – Términos y condiciones (2026-04)',
    titleAutoHint: 'Opcional. Si queda vacío usa la URL.',
    submitCreate: 'Crear fuente',
    submitSave: 'Guardar cambios',
    submitting: 'Guardando…',

    errors: {
      invalidUrl: 'Ingresá una URL válida',
      pdfUrlRequired: 'Pegá la URL de almacenamiento del PDF',
      titleRequired: 'El título es obligatorio',
      bodyRequired: 'El cuerpo es obligatorio',
      invalidContentId: 'Seleccioná un post válido',
      fileRequired: 'Adjuntá un archivo PDF',
      fileMustBePdf: 'El archivo debe ser un PDF',
      fileTooLarge: 'El PDF supera el límite de 10 MB',
    },

    url: {
      urlLabel: 'URL pública',
    },
    pdf: {
      hint: 'Subí el PDF a tu storage (S3/CDN) primero y pegá la URL resultante. La carga de archivos desde el browser la agregamos en v2.',
      urlLabel: 'URL del PDF',
      uploadHint: 'Subí el PDF directamente. Lo guardamos en storage y extraemos el texto.',
      fileLabel: 'Archivo PDF',
      dropZoneTitle: 'Hacé clic para seleccionar un PDF',
      dropZoneHint: 'PDF · hasta 10 MB',
      replaceFile: 'Reemplazar',
      removeFile: 'Quitar archivo',
      uploading: 'Subiendo…',
    },
    manual: {
      bodyLabel: 'Cuerpo de la fuente',
      bodyPlaceholder:
        'Pegá T&C, documentación interna, respuestas de FAQ o cualquier texto que sirva como verdad…',
    },
    content: {
      hint: 'Hacé referencia a un post ya publicado en esta organización. Se usa la última versión completada como fuente.',
      idLabel: 'Content ID (UUID)',
      pickerLabel: 'Post de origen',
      pickerPlaceholder: 'Buscar un post publicado…',
      pickerSearchPlaceholder: 'Filtrar por título…',
      pickerLoading: 'Cargando posts…',
      pickerEmpty: 'Sin resultados. Probá otro término.',
    },

    metadata: {
      sectionTitle: 'Metadata',
      advancedToggle: 'Configuración avanzada (opcional)',
      tagsLabel: 'Tags (separados por coma)',
      tagsPlaceholder: 'legal, tarifario, q2-2026',
      tagsHelp: 'Los tags sirven para filtrar y para guiar la relevancia de recuperación.',
      staleLabel: 'TTL de caché (horas)',
      effectiveFromLabel: 'Vigente desde',
      expiresAtLabel: 'Vence',
      authoritativeLabel: 'Fuente autoritativa',
      authoritativeHelp:
        'Las fuentes autoritativas tienen prioridad en generación y no pueden quedar desactualizadas en producción.',
    },
  },

  detail: {
    title: 'Detalle de la fuente',
    description:
      'Revisá el resumen generado, refrescá la caché y actualizá los controles de frescura.',
    notFound: 'No se encontró la fuente.',
    authoritative: 'Autoritativa',
    indexErrorLabel: 'Error de indexación',
    lastIndexed: 'Última indexación',
    cacheInfo: 'Caché: {{wordCount}} palabras, obtenida {{fetchedAt}}',
    summaryHeading: 'Resumen AI',
    summaryPending: 'El resumen va a estar disponible cuando termine la indexación.',
    bodyPreviewHeading: 'Preview del cuerpo',
    metadataHeading: 'Metadata',
  },

  deleteDialog: {
    title: '¿Borrar la fuente?',
    description:
      'La fuente "{{title}}" se borra suavemente y se excluye de retrieval inmediatamente.',
    confirm: 'Borrar',
    cancel: 'Cancelar',
    deleting: 'Borrando…',
  },

  toast: {
    createSuccess: 'Fuente creada',
    createError: 'No se pudo crear la fuente: {{message}}',
    updateSuccess: 'Fuente actualizada',
    updateError: 'No se pudo actualizar: {{message}}',
    reindexQueued: 'Reindexación disparada',
    reindexError: 'No se pudo reindexar: {{message}}',
    refreshSuccess: 'Caché refrescada',
    refreshError: 'No se pudo refrescar la caché: {{message}}',
    deleteSuccess: 'Fuente borrada',
    deleteError: 'No se pudo borrar: {{message}}',
    bulkCreateSuccess: 'Import listo: {{created}} creadas, {{skipped}} saltadas.',
    bulkCreateError: 'Falló el import masivo: {{message}}',
    uploadPdfSuccess: 'PDF subido y fuente creada',
  },
} as const
